import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import Icon from '@ant-design/icons';
import { ReactComponent as DashSvg } from '../../assets/dash-icon.svg';

export const DashIcon = (props: Partial<CustomIconComponentProps>): JSX.Element => {
  return <Icon component={DashSvg} {...props} />;
};
